exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".Photos__beforeWedding___1zfkE {\n  max-width: 920px;\n  padding: 0 16px;\n}\n\n.Photos__afterWedding___38YFW {\n  -webkit-box-flex: 1;\n      -ms-flex-positive: 1;\n          flex-grow: 1;\n  width: 100%;\n}\n\n.Photos__bodyAfterWedding___3RKlQ {\n  height: calc(100vh - 46px);\n}\n", ""]);

// exports
exports.locals = {
	"beforeWedding": "Photos__beforeWedding___1zfkE",
	"afterWedding": "Photos__afterWedding___38YFW",
	"bodyAfterWedding": "Photos__bodyAfterWedding___3RKlQ"
};